// @ts-nocheck
import axios from 'axios';
import { BASE_URL } from '../../../../queries/useDataEngine';

export const LandscapeService = {
  getLandScapeData: (params, loader = true) =>
    axios.get(BASE_URL + '/model-landscape', {
      params,
      loader,
    }),

  getLandScapeViewEntities: (params, loader = false) =>
    axios.get(BASE_URL + '/user-personalized-landscape', {
      params,
      loader,
    }),

  saveLandscapeViewEntities: (payload, loader = true) =>
    axios.put(BASE_URL + '/user-personalized-landscape', payload, {
      loader,
    }),

  createLandscapeView: (payload, loader = true) =>
    axios.post(BASE_URL + '/user-personalized-landscape', payload, {
      loader,
    }),

  getLandScapeSingleEntity: (params, loader = false) =>
    axios.get(BASE_URL + '/landscape-single-entity', {
      params,
      loader,
    }),

  getLandscapeSavedViews: (params, loader = true) =>
    axios.get(BASE_URL + '/landscape-views', {
      params,
      loader,
    }),

  deleteLandscapeSavedViews: (params, loader = true) =>
    axios.delete(BASE_URL + '/landscape-views', {
      params,
      loader,
    }),
};
